<template>
  <el-form v-loading="loading" :model="dealForm" label-width="80px">
    <el-row>
      <el-col :span="24">
        <el-form-item label="协议名称" prop="name">
          <span>{{ dealForm.name }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-tabs v-model="tabIndex">
          <el-tab-pane
            v-for="(typeItem, typeIndex) in dealForm.protocolVersionResultList"
            :key="typeIndex"
            :name="typeItem.versionId"
          >
            <template slot="label">
              <Ellipsis :texts="typeItem.protocolVersion" />
            </template>
            <el-col :span="12">
              <el-form-item
                :prop="`protocolVersionResultList.${typeIndex}.protocolVersion`"
                label="协议版本"
              >
                <span>{{ dealForm.protocolVersionResultList[typeIndex].protocolVersion }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="`protocolVersionResultList.${typeIndex}.simpleName`"
                label="协议简称"
              >
                <span>{{ dealForm.protocolVersionResultList[typeIndex].simpleName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件">
                <el-table
                  :data="dealForm.protocolVersionResultList[typeIndex].fileList"
                  v-if="dealForm.protocolVersionResultList[typeIndex].fileList.length > 0"
                >
                  <el-table-column
                    width="60"
                    type="index"
                    label="序号"
                    align="center"
                    :resizable="false"
                  ></el-table-column>
                  <el-table-column
                    label="文件名"
                    prop="name"
                    align="center"
                    width="558"
                    :resizable="false"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="100" :resizable="false">
                    <template slot-scope="{ row }">
                      <span style="margin-right: 8px" class="preBtn wordBtn" @click="seeFile(row)"
                        >预览</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <span v-else>-</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="moment-box">
              <el-form-item label="备注">
                <el-table
                  :data="dealForm.protocolVersionResultList[typeIndex].remark"
                  v-if="dealForm.protocolVersionResultList[typeIndex].remark.length > 0"
                  stripe
                >
                  <el-table-column width="329" align="center" label="名称" prop="name">
                  </el-table-column>
                  <el-table-column width="329" align="center" label="值" prop="value">
                  </el-table-column>
                </el-table>
                <span v-else>-</span>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="moment-box">
              <el-form-item label="添加时间">
                {{ dealForm.protocolVersionResultList[typeIndex].createTime }}
              </el-form-item>
            </el-col>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import dealApi from 'api/home/deal-mangement';
import Ellipsis from '@/components/Ellipsis';
import config from '@/config';
export default {
  components: {
    Ellipsis
  },
  data() {
    return {
      tabIndex: '',
      dealForm: {
        name: '',
        protocolVersionResultList: [
          {
            protocolVersion: '',
            simpleName: '',
            fileList: [],
            remark: [],
            createTime: ''
          }
        ]
      },
      id: '',
      loading: false
    };
  },
  methods: {
    init(id, tabIndex) {
      this.tabIndex = tabIndex;
      this.id = id;
      this.id && this.getDealDetail();
    },
    reset() {
      this.$emit('getIndex', this.tabIndex);
      this.dealForm = {
        name: '',
        protocolVersionResultList: [
          {
            protocolVersion: '',
            simpleName: '',
            fileList: [],
            remark: []
          }
        ]
      };
      this.tabIndex = '0';
      this.id = '';
      this.loading = false;
    },
    getDealDetail() {
      this.loading = true;
      dealApi
        .getDealDetail({ id: this.id })
        .then(res => {
          const { data, code } = res.data;
          if (code !== 200) {
            return;
          }
          this.dealForm = {
            name: data.protocolName,
            protocolVersionResultList: data.protocolVersionResultList.map(item => {
              return {
                versionId: item.id,
                protocolVersion: item.protocolVersion,
                fileList: item.fileInfoList.map(item => {
                  return {
                    url: item.fileUrl,
                    name: item.fileOriginName,
                    data: item.fileId
                  };
                }),
                remark: JSON.parse(item.remark).map(item => {
                  let obj = { name: item.name, value: item.value || item.val };
                  return obj;
                }),
                simpleName: item.simpleName || '-',
                createTime: item.createTime
              };
            })
          };
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    seeFile(file) {
      // let url = `${config.preview_url}/onlinePreview?url=${file.url}`;
      // window.open(url);
    }
  }
};
</script>
<style lang="less" scoped>
.preBtn {
  color: #409dfb;
}
.wordBtn {
  cursor: pointer;
}
</style>